import { render } from "./TwinFiguresDashboard.vue?vue&type=template&id=8e4f6d4e&scoped=true"
import script from "./TwinFiguresDashboard.vue?vue&type=script&lang=js"
export * from "./TwinFiguresDashboard.vue?vue&type=script&lang=js"

import "./TwinFiguresDashboard.vue?vue&type=style&index=0&id=8e4f6d4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e4f6d4e"]])

export default __exports__